const OXFORD_GROUP_ID = 49;

export const isGroupOxford = (groupId) => {
  if (!groupId) return false;

  return groupId == OXFORD_GROUP_ID;
};
